import React from 'react'
import { LocationPreset } from 'services/api/entities/catalog/packages/locationPackage'
import { ProductPresetField } from '../ProductPresetField'
import { OnlyWithPresetsOrId } from '../eventPackage/package/common'
import { Box, Container } from '@mui/material'

type Props = {
  pkg?: OnlyWithPresetsOrId<LocationPreset>
}

const LocationPackageReadonlyPresetsList: React.FC<Props> = ({ pkg }) => {
  return (
    <Container>
      <Box display="flex" flexDirection="column">
        {pkg &&
          typeof pkg !== 'number' &&
          pkg.presets.map((preset, index) => (
            <React.Fragment key={preset.id}>
              <h4>{`${index + 1}) `}Preset</h4>
              <ProductPresetField record={preset} />
              {!!preset.arrangement && (
                <ProductPresetField label="Arrangement: " record={preset} />
              )}
            </React.Fragment>
          ))}
      </Box>
    </Container>
  )
}

export default LocationPackageReadonlyPresetsList
